<template>
  <div class="warp">
    <!--导航栏 start-->
    <div class="nav-bar">
      <van-nav-bar left-text="返回" fixed title="商户查询" left-arrow @click-left="onClickLeft">
        <!--通过插槽自定义导航栏右侧的内容 start-->
        <template #right>
          <van-icon name="wap-home-o" size="20" @click="onClickRight" />
        </template>
        <!--通过插槽自定义导航栏右侧的内容 end-->
      </van-nav-bar>
    </div>
    <!--导航栏 end-->
    <div class="center">
      <van-tabs v-model="active" @change="changeActive">
        <van-tab title="商户信息">
          <!--内容 start-->
          <div>
            <div style="display: flex;justify-content: flex-end;">
              <van-button
                size="small"
                type="danger"
                v-if="info.is_electronic == 0"
                @click="sign(info.merchant_id)"
                style="margin:0 10px;"
              >电子签约</van-button>
              <van-button
                size="small"
                type="danger"
                v-if="info.incoming_status == 0"
                @click="netIn(info.merchant_id)"
              >入网</van-button>
              <van-button
                size="small"
                type="danger"
                v-if="info.is_wx_auth == 0 && info.incoming_status == 1"
                @click="authentication(info.merchant_id,'wechat')"
                style="margin:0 10px;"
              >微信认证</van-button>
              <van-button
                size="small"
                type="danger"
                v-if="info.is_al_auth == 0 && info.incoming_status == 1"
                @click="authentication(info.merchant_id,'alipay')"
                style="margin:0 10px;"
              >支付宝认证</van-button>
            </div>
            <van-cell title="电子签约" v-if="info.is_electronic == 0" value="未签约" />
            <van-cell title="电子签约" v-if="info.is_electronic == 1" value="签约成功" />
            <van-cell title="入网" v-if=" info.incoming_status == 0" value="未入网" />
            <van-cell title="入网" v-if="info.incoming_status == 1" value="入网成功" />
            <van-cell title="入网" v-if="info.incoming_status == 2" value="入网中" />
            <van-notice-bar
              v-if="info.fail_msg"
              wrapable
              :scrollable="false"
              :text="info.fail_msg"
            />
            <van-notice-bar color="#1989fa" background="#ecf9ff">商户信息</van-notice-bar>
            <van-cell title="商户编号" :value="info.merchant_num" />
            <van-cell title="商户名称" :value="info.store_name" />
            <van-cell title="门店电话" :value="info.store_tel" />
            <van-cell title="归属地区" :value="info.stoe_area_cod" />
            <van-cell title="联系地址" :value="info.store_address" />
            <van-cell
              v-if="info.is_business_license != '00'"
              title="营业执照名"
              :value="info.bse_lice_nm"
            />
            <van-cell
              v-if="info.is_business_license != '00'"
              title="营业执照号"
              :value="info.bus_lic_no"
            />
            <van-cell
              v-if="info.is_business_license != '00'"
              title="营业执照地址"
              :value="info.bus_lic_address"
            />
            <van-cell
              v-if="info.is_business_license != '00'"
              title="营业执照有效期"
              :value="info.bus_exp_dt"
            />
          </div>
          <!--身份信息 start-->
          <div>
            <van-notice-bar color="#1989fa" background="#ecf9ff">法人信息</van-notice-bar>
            <van-cell title="法人姓名" :value="info.crp_nm" />
            <van-cell title="法人身份证号" :value="info.crp_id" />
            <van-cell title="身份证有效期" :value="info.crp_exp_dt" />
          </div>
          <!--身份信息 end-->
          <!--我的银行卡 start-->
          <div style="margin-top: 10px">
            <van-notice-bar color="#1989fa" background="#ecf9ff">负责人信息</van-notice-bar>
            <van-cell title="负责人姓名" :value="info.s_legal_name" />
            <van-cell title="负责人身份证号" :value="info.s_legal_id" />
            <van-cell title="联系电话" :value="info.s_legal_phone" />
            <!-- <van-cell title="联系人邮箱" :value="info.s_legal_mailbox" /> -->
          </div>
          <!--我的银行卡 end-->

          <!--内容 end-->
        </van-tab>
        <van-tab title="商户活动">
          <activity :merchant_id="merchant_id" />
        </van-tab>
        <van-tab title="商户核销">
          <verification :merchant_id="merchant_id" />
        </van-tab>
      </van-tabs>
    </div>
    <van-loading type="spinner" class="loading" color="#1989fa" v-show="is_loading"/>
  </div>
</template>
<script>
import merchant_activity from "./merchant_components/activity";
import verification from "./merchant_components/verification";
import { Toast, Dialog, Notify } from "vant";
export default {
  components: {
    activity: merchant_activity,
    verification,
  },
  // name: "MerchantInfo", //基本信息
  data() {
    return {
      info: [],
      active: 0,
      activityPage: 0,
      activityLimit: 10,
      merchant_id: "",
      is_loading:false,
    };
  },
  methods: {
    //认证 Authentication
    authentication(id, type) {
      console.log(id, type);
      let params = {
        id: id,
        type: type,
      };
      if (type == "wechat") {
        this.$router.push({
          path: "/WxAuthentication",
          query: { form: JSON.stringify(params) },
        });
      } else {
        this.$router.push({
          path: "/zfbAuthentication",
          query: { form: JSON.stringify(params) },
        });
      }
    },
    // 电子签约
    sign(id) {
      console.log(id);
      this.$router.push({
        path: "/signUp",
        query: { id: id },
      });
    },
    // 入网
    netIn(id) {
      console.log(id);
      // Toast.loading({
      //   message: "提交中...",
      //   forbidClick: true,
      //   loadingType: "spinner",
      // });
      this.is_loading = true;
      this.$http
        .get("/wechat/api.merchant/doIncoming", {
          params: {
            merchant_id: id,
          },
        })
        .then((response) => {
          console.log(response);
          // Toast.clear();
          this.is_loading = false;
          if (response && response.data.code == 200) {
            Dialog.confirm({
              title: "温馨提示",
              message: response.data.msg,
            })
              .then(() => {
                this.$router.go(-1);
                // VueCookie.remove("payCode");
                // //跳转首页
                // window.location.href = "/SalesmanHome";
              })
              .catch(() => {
                // on cancel
              });
          } else {
            Dialog.confirm({
              title: "温馨提示",
              message: response.data.msg,
            })
              .then(() => {})
              .catch(() => {});
          }
        });
    },
    // 返回上一级
    onClickLeft() {
      // 返回商户信息
      this.$router.push("/Merchantlist");
    },
    // 右侧icon跳转至商户首页
    onClickRight() {
      // 返回商户首页
      this.$router.push("/SalesmanHome");
    },
    //初始化页面
    Basic() {
      var that = this;
      console.log(this.$route.params);
      this.merchant_id = this.$route.params.id * 1;
      this.$http
        .get("/wechat/api.salesman/merchantInfo", {
          params: {
            id: this.$route.params.id,
          },
        })
        .then((response) => {
          that.info = response.data.data;
        });
    },
    changeActive(i) {
      console.log(i);
      this.active = i;
    },
    // 获取商户活动列表
  },
  mounted() {
    this.Basic();
  },
  watch: {
    $route(to, from) {
      this.$router.go(0);
    },
  },
};
</script>

<style scoped>
.content_title {
  font-size: 18px;
}
.warp {
  padding-top: 46px;
}
.loading{
  position: absolute;
  top: 50%;
  left: 50%;
}
/* .nav-bar{
    overflow: hidden;
    height: 46px;
} */
</style>